import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface BackofficeCompanyContactsData {
  companyContactId?: number,
  contactName?: string | null,
  contactTitle?: string | null,
  contactPhone?: string | null,
  contactEmail?: string | null 
}

export interface BackofficeCompanyContactsState {
    status: number,
    message: string,
    path: string,
    data: BackofficeCompanyContactsData[]
}

const initialState: BackofficeCompanyContactsState = {
  status: 0,
  message: '',
  path: '',
  data: [],
}

export const backofficeCompanyContactsSlice = createSlice({
  name: 'backofficeCompanyContacts',
  initialState,
  reducers: {
    handleContacts: (state, action: PayloadAction<BackofficeCompanyContactsState>) => {
      state.status = action.payload.status
      state.message = action.payload.message
      state.path = action.payload.path
      state.data = action.payload.data
    }
  }
})

export const { handleContacts } = backofficeCompanyContactsSlice.actions